<template>
  <div class="template_wrapper" >
    <div class="template_title" style="vertical-align: top;"><span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span>{{moduel.name}}</div>
    <div style="display: inline-block; width:88%;" >
      <vue-ueditor-wrap v-model="content" :config="myConfig" :destroy="true" @ready="ready" style="line-height: 22px"></vue-ueditor-wrap>
    </div>
    <!-- <span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span> -->
    <div style="width:398px;word-wrap:break-word;position:fixed;left:-10000px;line-height:22px;" ref="computed_content" v-html='content'></div>
  </div>
</template>

<script>
export default {
  props: ['moduel', 'data', 'type', "input_callback"],
  data: ()=>{
    return {
      content: '',
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        toolbars: [
            ['fontsize', 'bold', 'italic','|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist',]
          ],
        insertorderedlist:{
          'num': '1,2,3...',
        },
        insertunorderedlist :{
          'disc': '● 小黑点',
        },
        elementPathEnabled: false,
        wordCount:false
      },
      editor: null,
      status: false,
    }
  },
  created(){
  },
  mounted(){
      console.log("mounted",this.data);
      this.content = this.data.description === null ? "": this.data.description;
      this.status = true;
  },
  destroyed(){
      this.clear();
  },
  methods: {
    clear(){
      this.status = false;
      this.content = '';
    },
    ready: function(_editor){
      this.editor = _editor;
    },
  },
  watch: {
    'content':{
      handler(newName, oldName) {
        if(this.status === false) return;
        // console.log("watch",newName, oldName);
        var that =this;
        this.$nextTick(function(){
          var _content_height = that.$refs["computed_content"].offsetHeight;
          that.content_height = _content_height;
          if(that.data.description !== that.content){
            // console.log("description",that.content_height);
            that.input_callback(that.content,that.content_height);
          } 
        });
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ue_editor.vue